import React, { useState, useEffect } from 'react';
import { useSnackbar } from 'notistack';
import api from '@http/api';

import { Grid, IconButton, Card } from '@material-ui/core';
import { VisibilityOff, Search} from '@material-ui/icons';
import ButtonComponent from '@components/Shared/Buttons/Button';
import Button from '@components/Shared/Buttons/Button';
import { Form, Select as SelectAntd,  Input, Spin, Radio, Switch } from 'antd';
import { MaskedInput } from 'antd-mask-input';
import { FormatDate } from '@utils/formats';

import TableCustomKeysNoPagination from '@src/components/Shared/Tables/TableCustomKeysNoPagination';

import Services, {
  IGetAllProgramasTable,
  IRequestPrograma,
} from './services';

const columnsLabel = {
  id: 'ID',
  nome: 'Programa',
  dataCadastro: 'Data cadastro',
};

interface IDiasSemana {
  id: number;
  descricao: string;
}

const SolicitacaoIntencaoMissa: React.FC = () => {
  const { enqueueSnackbar } = useSnackbar();
  const [loading, setLoading] = useState(true);
  const [data, setData] = useState<IGetAllProgramasTable[]>([]);
  const [formref] = Form.useForm();

  const [loadingCreate, setLoadingCreate] = useState(false);
  const [loadingCreateHorario, setLoadingCreateHorario] = useState(false);
  const [habilitarBotao, setHabilitarBotao] = useState(false);

  const [diaSemanaSelect, setDiaSemanaSelect] = useState<any>();

  const [diasSemana, setDiasSemana] = useState<IDiasSemana[]>([
    { id: 1, descricao: 'Segunda-Feira' },
    { id: 2, descricao: 'Terça-Feira' },
    { id: 3, descricao: 'Quarta-Feira' },
    { id: 4, descricao: 'Quinta-Feira' },
    { id: 5, descricao: 'Sexta-Feira' },
    { id: 5, descricao: 'Sábado' },
    { id: 5, descricao: 'Domingo' },

  ]);

  async function loadGetAllProgramas() {
    setLoading(true);
    await api
      .get('/api/Programa/GetAll')
      .then(response => {
        const items = response.data;
        const itemData: IGetAllProgramasTable[] = items.map((item: IGetAllProgramasTable) => ({
          id: item.id,
          nome: item.nome,
          dataCadastro: FormatDate(item.dataCadastro),
        }));

        setData(itemData);
        setLoading(false);
      })
      .catch(error => {
        alert(error);
      });
  }



  async function onSubmit(values: any) {
      setLoadingCreate(true);

      const createSolicitacao: IRequestPrograma = {
        nome: values.nome
      };

      const service = new Services();
      const { error, response } = await service.CreatePrograma(createSolicitacao);

      setLoadingCreate(false);

      if (!error) {
        enqueueSnackbar(`Cadastro finalizado com sucesso!`, {
          variant: 'success',
          anchorOrigin: { horizontal: 'right', vertical: 'bottom' },
        });

        clearDados();
        setHabilitarBotao(false);

        loadGetAllProgramas();

      } else {
        enqueueSnackbar(`Ocorreu um erro`, {
          variant: 'error',
          anchorOrigin: { horizontal: 'right', vertical: 'bottom' },
        });
      }
  }

  const loadDesativarPrograma = async (id: number) => {
    const services = new Services();
    const recuseSolicitacaoResponse = await services.DesativarPrograma({ id });

    if (!recuseSolicitacaoResponse.error) {
      enqueueSnackbar(`Desativado com sucesso`, {
        variant: 'success',
        anchorOrigin: { horizontal: 'right', vertical: 'bottom' },
      });

      loadGetAllProgramas();

    } else {
      enqueueSnackbar(`Ocorreu um erro`, {
        variant: 'error',
        anchorOrigin: { horizontal: 'right', vertical: 'bottom' },
      });
    }
  };

  const clearDados = () => {
    formref.setFieldsValue({
      programa: '',
    });

  };


  useEffect(() => {
    loadGetAllProgramas();
    window.document.title = 'CRM - Programas';
  }, []);

  return (
    <Grid container>
      <Grid
        container
        item
        sm={12}
        //justify="space-around"
        xs={12}
        lg={12}
        style={{ marginTop: 20 }}
      >
        {/* FORMULARIO  */}
        <Grid item lg={12} sm={12} xs={12}>
          <Spin
            size="large"
            spinning={loadingCreate}
            tip="Enviando dados..."
          >
            <Form
              form={formref}
              size="middle"
              layout="vertical"
              scrollToFirstError={true}
              onFinish={onSubmit}
              labelAlign="left"
              labelCol={{
                span: 24,
              }}
              wrapperCol={{
                span: 24,
              }}
              requiredMark={false}
              initialValues={{

                dia_semana: '',
                horario: '',
              }}
            >

              <Grid container item lg={12} sm={12} xs={12} style={{ paddingTop: 10 }}>

                {/* Lista dos horários cadastrados  */}
                <Grid container item lg={6} sm={6} xs={12} style={{ padding: 0 }}>
                  <Card style={{ padding: 20, borderRadius: 8, width: 550,  boxShadow: '0 2px 8px rgba(0,0,0,0.1)'}}>

                    <Grid
                      item
                      lg={12}
                      xs={12}
                      style={{ paddingRight: 2, paddingLeft: 2, paddingTop: 5 }}
                    >

                      <TableCustomKeysNoPagination
                        loading={loading}
                        columns={[columnsLabel]}
                        FieldsBold={['nome']}
                        data={data}
                        keys={[
                          'id',
                          'nome',
                          'dataCadastro',
                        ]}
                        ActionHeader={'Desativar'}
                        Actions={[
                          {
                            Button: (item: IGetAllProgramasTable) => {
                              return (
                                <Grid container justifyContent="center">
                                  <IconButton
                                    onClick={() => {loadDesativarPrograma(item.id)}}
                                  >
                                    <VisibilityOff />
                                  </IconButton>
                                </Grid>
                              );
                            },
                          },
                        ]}
                      />
                    </Grid>
                  </Card>
                </Grid>

                {/* Novo cadastro de horário  */}
                <Grid container item lg={5} sm={5} xs={12} style={{ padding: 0 }}>
                  <Card style={{ padding: 20, borderRadius: 8, width: 450, boxShadow: '0 2px 8px rgba(0,0,0,0.1)' }}>
                    <Grid item lg={7} md={7} xs={7} style={{ paddingLeft: 250, paddingRight: 5, alignSelf: 'end' }}>
                      <ButtonComponent
                        fullWidth
                        style={{ height: 46, borderRadius: 5}}
                        color={"secondary"}
                        onClick={() => {
                          setHabilitarBotao(true)
                        }}
                      >
                        Novo programa
                      </ButtonComponent>
                    </Grid>

                    <Grid container>
                      <Grid item lg={12} xs={12} style={{ paddingLeft: 10, paddingRight: 10 }}>
                        <Form.Item name="nome" label="Programa"
                          rules={[
                            {
                              required: true,
                              message: 'Adicione um programa',
                            },
                          ]}
                        >
                          <Input   disabled={habilitarBotao !== true} />
                        </Form.Item>
                      </Grid>
                    </Grid>

                    <Grid
                      container
                      justify="center"
                      alignItems="center"
                      item
                      lg={12}
                      md={12}
                      xs={12}
                    >
                      <Grid item lg={4} md={4} xs={12} style={{ paddingTop: 10, paddingLeft: 5, paddingRight: 5 }}>
                        <ButtonComponent
                          color="default"
                          fullWidth
                          disabled={habilitarBotao !== true}
                          onClick={clearDados}
                        >
                          Cancelar
                        </ButtonComponent>
                      </Grid>

                      <Grid item lg={4} md={4} xs={12} style={{ paddingTop: 10, paddingLeft: 5, paddingRight: 5 }}>
                        <ButtonComponent
                          color="primary"
                          fullWidth
                          type="submit"
                          disabled={habilitarBotao !== true}
                        >
                          Salvar
                        </ButtonComponent>
                      </Grid>
                    </Grid>
                  </Card>
                </Grid>
              </Grid>
            </Form>
          </Spin>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default SolicitacaoIntencaoMissa;
